/* Ad route: one live ad's home-page clicks sent on to another page (see snippets/ad-route.liquid). Routes are
   [lower-cased start of the ad's name as it arrives in utm_content, path]. Never throws: a broken route must not
   touch the home page. */
(function () {
  try {
    var routes = [['r23 · tree story · aleksandra', '/products/jade-oil']];
    var tag = document.currentScript;
    var q = new URLSearchParams(location.search);
    if ((q.get('utm_source') || '').toLowerCase() !== 'facebook') return;
    var content = (q.get('utm_content') || '').toLowerCase();
    var base = ((tag && tag.getAttribute('data-root')) || '/').replace(/\/$/, '');
    for (var i = 0; i < routes.length; i++) {
      if (content.indexOf(routes[i][0]) === 0) {
        location.replace(base + routes[i][1] + location.search + location.hash);
        return;
      }
    }
  } catch (e) {}
})();
